// src/App.js
import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import Header from './components/Header/Header.js';
import Footer from './components/Footer/Footer.js';
import ErrorBoundary from './components/ErrorBoundary.js';

// Lazy load pages for better performance
const HomePage = lazy(() => import('./pages/Home/Home.js'));
const CareersPage = lazy(() => import('./pages/CareersPage/CareersPage.js'));
const WhyJoinPage = lazy(() => import('./pages/WhyJoinUsPage/WhyJoinTeam.js'));
const BrowseJobsPage = lazy(() => import('./pages/BrowseJob/BrowseJobsPage.js'));
const JobApplicationForm = lazy(() => import('./pages/JobApplication/JobApplicationForm.js'));

// Loading component
const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh'
  }}>
    <div style={{ textAlign: 'center' }}>
      <div className="spinner" style={{
        width: '50px',
        height: '50px',
        border: '3px solid #f3f3f3',
        borderTop: '3px solid #0e1c6f',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        margin: '0 auto 20px'
      }}></div>
      <p>Loading page...</p>
    </div>
  </div>
);

// Add spinner animation to global CSS or style tag
const spinnerStyle = document.createElement('style');
spinnerStyle.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(spinnerStyle);

const App = () => {
  // Log environment info in development
  if (process.env.NODE_ENV === 'development') {
    console.log('🔧 Running in development mode');
    console.log('📡 API URL:', process.env.REACT_APP_BASE_URL);
  } else {
    console.log('🚀 Running in production mode');
  }

  return (
    <ErrorBoundary>
      <Header />
      <Toaster 
        position="top-right" 
        reverseOrder={true}
        toastOptions={{
          duration: 4000,
          success: {
            style: {
              background: '#10b981',
              color: 'white',
            },
          },
          error: {
            style: {
              background: '#ef4444',
              color: 'white',
            },
          },
        }}
      />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/why-join-our-team" element={<WhyJoinPage />} />
          <Route path="/browse-jobs" element={<BrowseJobsPage />} />
          <Route path="/apply" element={<JobApplicationForm />} />
        </Routes>
      </Suspense>
      <Footer />
    </ErrorBoundary>
  );
};

export default App;